import styles from "./InnerContainer.module.scss";

type InnerContainerProps = {
  children: React.ReactNode;
};

export function InnerContainer({ children }: InnerContainerProps) {
  return <div className={styles.innerContainer}>{children}</div>;
}
